import { Link, useLocation } from "react-router-dom";
import { chatEntryTitleMap, isChatEntry } from "@/config/chat.config";
import { myCoachPageSubtitle } from "@/config/coachingIntro";
import type { ChatEntry } from "@/types/chat";

export const AIMentorPageHeader = () => {
  const location = useLocation();
  const raw = (location.state as { entry?: unknown } | null)?.entry;
  const entry: ChatEntry = isChatEntry(raw) ? raw : "ai_mentor";

  return (
    <div className="flex items-start justify-between gap-4 pr-3">
      <div className="min-w-0 flex-1">
        <h1 className="font-literata text-2xl font-semibold text-white md:text-3xl">{chatEntryTitleMap[entry]}</h1>
        {entry === "get_coaching" && (
          <p className="mt-1 max-w-3xl font-inter text-sm leading-snug text-white/80 md:text-base">
            {myCoachPageSubtitle}
          </p>
        )}
      </div>
      <Link
        to="/history"
        className={`shrink-0 text-white transition-colors ${
          location.pathname === "/history" ? "font-bold" : "text-white/70 hover:text-white"
        }`}
      >
        History
      </Link>
    </div>
  );
};
